import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CheckboxSetting from '../settings/CheckboxSetting';
import { Form, Row } from 'react-bootstrap';
import { SelectFieldModel } from '../../../../../../models/form/fields/select';
import ColorSetting from '../settings/ColorSetting';
import { updateSelectedField, selectedFieldSelector } from '../../../../../../slices/formadmin';
import { RootState } from '../../../../../../store';
import CultureTextSetting from '../settings/CultureTextSetting';

const SelectProperties: FC = () => {
  const field = useSelector(selectedFieldSelector) as SelectFieldModel;
  const selectedLanguage = useSelector((state: RootState) => state.formAdmin.selectedLanguage) as string;
  const dispatch = useDispatch();

  return (
    <Form>
      <Row className="align-items-center">
        <CultureTextSetting
          id={`field.${field.id}.text`}
          culture={selectedLanguage}
          value={field.text}
          label="adminProperties.fields.common.text"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                text: val,
              }),
            )
          }
        />
        <ColorSetting
          value={field.textColor}
          label="adminProperties.fields.common.textColor"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                textColor: val,
              }),
            )
          }
        />
        <CheckboxSetting
          id={field.id + 'hiddenText'}
          checked={field.hiddenText}
          label="adminProperties.fields.common.hiddenText"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                hiddenText: val,
              }),
            )
          }
        />
      </Row>
      <Row>
        <CheckboxSetting
          id={field.id + 'required'}
          checked={field.required}
          label="adminProperties.fields.common.required"
          size={6}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                required: val,
              }),
            )
          }
        />
        <CheckboxSetting
          id={field.id + 'enabled'}
          checked={field.enabled}
          label="adminProperties.fields.common.enabled"
          size={6}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                enabled: val,
              }),
            )
          }
        />
      </Row>
      <Row>
        <CheckboxSetting
          id={field.id + 'visible'}
          checked={field.visible}
          label="adminProperties.fields.common.visible"
          size={6}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                visible: val,
              }),
            )
          }
        />
        <CheckboxSetting
          id={field.id + 'excludeFromReport'}
          checked={field.excludeFromReport}
          label="adminProperties.fields.common.excludeFromReport"
          size={6}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                excludeFromReport: val,
              }),
            )
          }
        />
      </Row>
      <Row>
        <CultureTextSetting
          id={`field.${field.id}.placeholder`}
          culture={selectedLanguage}
          value={field.placeholder}
          label="adminProperties.fields.common.placeholder"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                placeholder: val,
              }),
            )
          }
        />
      </Row>
    </Form>
  );
};

export default SelectProperties;
